"use client";
import React, { useState } from "react"; // Import useState
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
// import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Link from "next/link";

import Image from "next/image";
import leftarr from "@/public/home-images/left-arrow.png";
import rightarr from "@/public/home-images/right-arrow.png";
import playbtn from "@/public/specialities/patient-testimonial/play-button.png";
import CustomLink from "../common/custom-link";

function DoctorsVideos(props) {
  // console.log(props.data.data[0].doctor?.data.attributes)
  const [isOpen, setOpen] = useState(false);
  const [currentVideoId, setCurrentVideoId] = useState("");

  function extractYouTubeVideoId(url) {
    const regularMatch = url.match(/v=([a-zA-Z0-9_-]{11})/);
    const shortsMatch = url.match(/shorts\/([a-zA-Z0-9_-]{11})/);
    return regularMatch ? regularMatch[1] : shortsMatch ? shortsMatch[1] : null;
  }

  // console.log(props.data);
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handleNext = () => {
    slider.slickNext();
  };

  const handlePrevious = () => {
    slider.slickPrev();
  };

  let slider;
  return (
    <>
      {props?.data.data[0]?.attributes.doctorVideo.data.length > 0 ? (
        <div className="custom-container py-8">
          <h2 className="text-primaryBlue font-bold text-4xl text-left mb-10">{`Videos by ${props.data.data[0].attributes.doctorName}`}</h2>
          <div className="relative">
            <Slider {...settings} ref={(c) => (slider = c)}>
              {props?.data.data[0]?.attributes.doctorVideo.data.map((e, i) => (
                <div key={i}>
                  <div className="group relative border-solid border rounded-3xl overflow-hidden border-gray-300 mx-2.5">
                    <div>
                      {/* <Image
                        src={`${process.env.NEXT_PUBLIC_BE_URL}${e.attributes.doctorVideo.data[0].attributes.url}`}
                        alt="events"
                        title="events"
                        width={380}
                        height={220}
                        className="w-full object-cover object-center rounded-3xl"
                      /> */}
                      <div className="relative aspect-video overflow-hidden rounded-3xl">
                        <Image
                          src={`${process.env.NEXT_PUBLIC_BE_URL}${e.attributes.doctorVideo.data[0].attributes.url}`}
                          alt="events"
                          title="events"
                          fill
                          className="object-cover object-center"
                        />
                      </div>
                      <Image
                        style={{ filter: "invert(1)" }}
                        className="absolute w-12 h-12 left-2/4 top-2/4 -translate-y-2/4 -translate-x-2/4 max-h-96 max-w-2xl object-cover object-center cursor-pointer"
                        src={playbtn}
                        alt="apex-hospitals"
                        title="apex-hospitals"
                        width={250}
                        height={250}
                        onClick={() => {
                          setOpen(true);
                          setCurrentVideoId(
                            extractYouTubeVideoId(
                              e?.attributes?.doctorVideoLink
                            )
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>

            <div className="flex justify-between">
              <button
                className="lg:block hidden rounded-full border border-primaryGrey py-3 px-4 absolute -translate-y-1/2 -left-12 top-2/4"
                onClick={handlePrevious}
              >
                <Image
                  src={leftarr}
                  alt="left arrow"
                  title="left arrow"
                  height={24}
                  width={12}
                />
              </button>
              <button
                className="lg:block hidden rounded-full border border-primaryGrey py-3 px-4 absolute -right-12 -translate-y-1/2 top-2/4"
                onClick={handleNext}
              >
                <Image
                  src={rightarr}
                  alt="left arrow"
                  title="left arrow"
                  height={24}
                  width={12}
                />
              </button>
            </div>
          </div>
          <div className="text-center flex items-center justify-center pt-10">
            <CustomLink
              lang={props.lang}
              href="/videos"
              className="block w-fit text-primaryWhite bg-primaryBlue hover:bg-buttonbg hover:text-primaryWhite uppercase rounded-full px-8 py-3 mt-8"
            >
              Know More
            </CustomLink>
          </div>
        </div>
      ) : null}
      <ModalVideo
        channel="youtube"
        autoplay="1"
        isOpen={isOpen}
        videoId={currentVideoId}
        onClose={() => setOpen(false)}
      />
    </>
  );
}

export default DoctorsVideos;
